module.exports = __webpack_public_path__ + "static/img/LivePropertyMarketing.31caa4cd.jpeg";